import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="container">
      <h1>Privacy Policy</h1>
      <p>This privacy policy is intended to inform you about how your personal data is collected, used, and protected when you visit my web portfolio. In accordance with the General Data Protection Regulation (GDPR), your data is processed transparently and securely.</p>

      <h2>1. Data Controller</h2>
      <p>I am the data controller responsible for the personal data collected on this site. If you have any questions about data protection, you can contact me via the email address provided on this site.</p>

      <h2>2. Data Collected</h2>
      <p>The following personal data may be collected via the contact form and newsletter signup:</p>
      <ul>
        <li>First and last name</li>
        <li>Email address</li>
        <li>Company name (optional)</li>
        <li>Message content (for the contact form)</li>
      </ul>

      <h2>3. Use of Data</h2>
      <p>The data collected is used for the following purposes:</p>
      <ul>
        <li>Contact form: To respond to your inquiries or specific requests.</li>
        <li>Newsletter: To send you updates about my work, projects, or any relevant news related to my professional activities.</li>
      </ul>

      <h2>4. Legal Basis for Processing</h2>
      <p>The processing of your personal data is based on the following legal grounds:</p>
      <ul>
        <li>Contact form: Processing is necessary to communicate with you following your request.</li>
        <li>Newsletter: Your explicit consent when subscribing to the newsletter.</li>
      </ul>

      <h2>5. Data Retention</h2>
      <p>Personal data is retained only as long as necessary to fulfill the purposes for which it was collected. Data related to the newsletter will be kept until you choose to unsubscribe.</p>

      <h2>6. Your Rights</h2>
      <p>In accordance with the GDPR, you have the following rights regarding your personal data:</p>
      <ul>
        <li>Right of access: You may request to know what personal data is held about you.</li>
        <li>Right of rectification: You may request to correct inaccurate or incomplete information.</li>
        <li>Right to erasure: You may request the deletion of your data under certain conditions.</li>
        <li>Right to object: You can object at any time to the use of your data for marketing purposes.</li>
      </ul>

      <p>To exercise your rights, please contact me via the email address provided on this site.</p>

      <h2>7. Data Security</h2>
      <p>I take reasonable precautions to protect your personal data from loss, theft, unauthorized access, disclosure, or alteration.</p>

      <h2>8. Cookies</h2>
      <p>This website uses cookies to enhance user experience. The cookies used are strictly functional and do not collect personal data for marketing or profiling purposes.</p>
    </div>
  );
};

export default PrivacyPolicy;
